import {StringBuilder} from "../AppUtils";

export const SquareBriefInfo = ({row = []}) => {
    return (
        <div className="brief-information-card-details-containers">
            {row.map(({title, component}, index) => (
                <div key={index} className="brief-information-card-details-container">
                    <div className="brief-information-card-details-container-title">{title}</div>
                    {!!component && component}
                </div>
            ))}
        </div>
    );
};

export const BriefInfoRow = ({title, component}) => {
    return (
        <div className="brief-information-card-customer-information">
            <div className="brief-information-card-details-container-title">{title}</div>
            {!!component && component}
        </div>
    );
};

export const BriefWhereInfo = ({briefInfo}) => {
    return (
        <>
            {briefInfo.address ? (
                <div className="order-information-card-open-address-container">
                    <span>
                        {new StringBuilder()
                            .append(briefInfo.address)
                            .append(briefInfo?.floor ? "קומה" : "")
                            .append(briefInfo?.floor ? briefInfo.floor : "")
                            .toString()}
                    </span>
                </div>
            ) : null}
        </>
    );
};
